import { MainAnnouncement } from 'types/MainAnnouncement';
import { Link } from 'react-router-dom';
import { BASE_UPLOADED_IMG_URL } from '../../const/ConstBase';
import {
    announcementDetailUrl,
    announcementTypeUrl,
    announcementType,
} from 'helper/helper';

import './MainNoticeItemWithImage.scss';

interface Props {
    item: MainAnnouncement;
    type: string;
}

const MainNoticeItemWithImage = (props: Props) => {
    const url = announcementDetailUrl(props.item.n_seq, props.item.n_title);
    const cardType = announcementType(props.type);

    return (
        <>
            <div className='card-container'>
                <Link className='card-container-link' to={url}>
                    <div
                        className='card-container-image'
                        style={{
                            backgroundImage: `url(${
                                BASE_UPLOADED_IMG_URL +
                                props.item.n_summary_image
                            })`,
                        }}
                    />
                </Link>

                <div className='card-container-detail'>
                    <Link
                        className='card-category'
                        to={announcementTypeUrl(props.type)}
                    >
                        {cardType}
                    </Link>
                    <Link className='card-title' to={`${url}`}>
                        {props.item.n_title}
                    </Link>
                    <div className='card-date'>
                        Posted on {props.item.reg_date}
                    </div>
                    <Link className='card-read_more' to={`${url}`}>
                        Read More
                    </Link>
                </div>
            </div>
        </>
    );
};

export default MainNoticeItemWithImage;
